import { apiUrl } from '../config';
import { fetch } from '../utils/http';

export function postLoginStart(email, password) {
    return {
        type : 'SESSION_POST_LOGIN_START',
        email,
        password
    }
}

export function postLogin(email, password) {
    const url = `${apiUrl()}/auth/login`;
    return function(dispatch) {

        dispatch(postLoginStart(email, password));
        var data = new FormData();
        data.append('email', email);
        data.append('password', password);
        return fetch(url, {
            method : 'POST',
            body : data,
        })
        .then(response => response.json())
        .then(json => dispatch(postLoginSuccess(json)))
        .catch(error => {
            if(error.response)
                return error.response.json().then(error => dispatch(postLoginFailure(error)));
            else
                throw error
        })
        .catch(error => dispatch(postLoginFailure(error)));
    }
}

export function postLoginSuccess(json) {
    return {
        type : 'SESSION_POST_LOGIN_SUCCESS',
        user : json
    }
}

export function postLoginFailure(error) {
    return {
        type : 'SESSION_POST_LOGIN_FAILURE',
        error
    }
}

export function getUser(token) {
    const url = `${apiUrl()}/auth/user`;
    return function(dispatch) {
        dispatch(getUserStart());
        return fetch(url, {
            headers : {
                'Authorization' : 'Bearer ' + token
            }
        })
        .then(response => response.json())
        .then(json => dispatch(getUserSuccess(json)))
        .catch(error => dispatch(getUserFailure(error)));
    }
}

export function getUserStart() {
    return {
        type : 'SESSION_USER_GET_START'
    }
}

export function getUserSuccess(user) {
    return {
        type : 'SESSION_USER_GET_SUCCESS',
        user : user
    }
}

export function getUserFailure(error) {
    return {
        type : 'SESSION_USER_GET_FAILURE',
        error : error,
    }
}


export function logout() {
    return {
        type : 'SESSION_LOGOUT',
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/session.js
 **/